/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_No_Event_DeletedInputs */

const en_compare_event_groups_no_event_deleted = /** @type {(inputs: Compare_Event_Groups_No_Event_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No event (deleted)`)
};

const fr_compare_event_groups_no_event_deleted = /** @type {(inputs: Compare_Event_Groups_No_Event_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun événement (supprimé)`)
};

const de_compare_event_groups_no_event_deleted = /** @type {(inputs: Compare_Event_Groups_No_Event_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Ereignis (gelöscht)`)
};

const it_compare_event_groups_no_event_deleted = /** @type {(inputs: Compare_Event_Groups_No_Event_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento (eliminato)`)
};

const ru_compare_event_groups_no_event_deleted = /** @type {(inputs: Compare_Event_Groups_No_Event_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событий нет (удалено)`)
};

const es_compare_event_groups_no_event_deleted = /** @type {(inputs: Compare_Event_Groups_No_Event_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin evento (eliminado)`)
};

const zh_cn2_compare_event_groups_no_event_deleted = /** @type {(inputs: Compare_Event_Groups_No_Event_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无事件（已删除）`)
};

const ja_compare_event_groups_no_event_deleted = /** @type {(inputs: Compare_Event_Groups_No_Event_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントなし（削除済み）`)
};

const hi_compare_event_groups_no_event_deleted = /** @type {(inputs: Compare_Event_Groups_No_Event_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई घटना नहीं (हटा दी गई)`)
};

const pt_pt2_compare_event_groups_no_event_deleted = /** @type {(inputs: Compare_Event_Groups_No_Event_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento (excluído)`)
};

/**
* | output |
* | --- |
* | "No event (deleted)" |
*
* @param {Compare_Event_Groups_No_Event_DeletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_no_event_deleted = /** @type {((inputs?: Compare_Event_Groups_No_Event_DeletedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_No_Event_DeletedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_no_event_deleted(inputs)
	if (locale === "de") return de_compare_event_groups_no_event_deleted(inputs)
	if (locale === "it") return it_compare_event_groups_no_event_deleted(inputs)
	if (locale === "ru") return ru_compare_event_groups_no_event_deleted(inputs)
	if (locale === "es") return es_compare_event_groups_no_event_deleted(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_no_event_deleted(inputs)
	if (locale === "ja") return ja_compare_event_groups_no_event_deleted(inputs)
	if (locale === "hi") return hi_compare_event_groups_no_event_deleted(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_no_event_deleted(inputs)
	return en_compare_event_groups_no_event_deleted(inputs)
});